(() => {
  const globalKey = '__chloroPillProgression';

  if (window[globalKey]) {
    window[globalKey].refresh();
    return;
  }

  const instances = new Map();
  let ticking = false;

  const registerRoot = (root) => {
    if (!root || instances.has(root)) return;

    const steps = Array.from(root.querySelectorAll('[data-cp-progression-item]'));
    const meter = root.querySelector('[data-cp-progression-meter]');

    if (!steps.length) return;

    root.classList.add('is-scroll-ready');
    instances.set(root, { root, steps, meter });
  };

  const collect = (scope = document) => {
    if (scope.matches?.('[data-cp-progression]')) registerRoot(scope);
    scope.querySelectorAll?.('[data-cp-progression]').forEach(registerRoot);
  };

  const prune = () => {
    instances.forEach((instance, root) => {
      if (!document.documentElement.contains(root)) instances.delete(root);
    });
  };

  const updateInstance = ({ steps, meter }) => {
    const activationLine = window.innerHeight * 0.62;
    let activeIndex = 0;

    steps.forEach((step, index) => {
      if (step.getBoundingClientRect().top <= activationLine) activeIndex = index;
    });

    steps.forEach((step, index) => {
      step.classList.toggle('is-active', index <= activeIndex);
    });

    if (meter) {
      meter.style.height = `${((activeIndex + 1) / steps.length) * 100}%`;
    }
  };

  const update = () => {
    prune();
    instances.forEach(updateInstance);
    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  const refresh = (scope = document) => {
    collect(scope);
    requestUpdate();
  };

  window[globalKey] = { refresh };

  refresh();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);

  document.addEventListener('shopify:section:load', (event) => refresh(event.target));
  document.addEventListener('shopify:section:unload', requestUpdate);
  document.addEventListener('shopify:section:reorder', requestUpdate);
})();
